import React from 'react';
import { Button } from 'primereact/button';
import MessageDetail from "../../components/sturtural/MessageDetail";
import { Link } from "react-router-dom";

const TableData = ({data, handleDigitization, handleImpresion}) => {

    const iconstyle = {
        'width': "48px",
        'height': "48px",
        'borderRadius': "10px"
    };

    const handleStatus = (statusID, statusText) => {

        let color;
        let icon;
        let textcolor;

        switch (parseInt(statusID)) {
            case 3: //NUEVO
                color = 'gray-100';
                textcolor = 'gray-600';
                icon = 'pi pi-question';
            break;

            case 5: //RECHAZADOS
                color = 'orange-100';
                textcolor = 'orange-600';
                icon = 'pi pi-times';
            break;
            
            case 7: //APROBADO
                color = 'green-100';
                textcolor = 'green-600';
                icon = 'pi pi-check-circle';
            break;
           
            case 8: //POR_ASIGNAR
                color = 'cyan-100';
                textcolor = 'cyan-600';
                icon = 'pi pi-clock';
            break;

            case 9: //EN_REVISION
                color = 'yellow-600';
                textcolor = 'yellow-100';
                icon = 'pi pi-cog';
            break;
            
            case 10: //TERMINADO
                color = 'green-300';
                textcolor = 'green-600';
                icon = 'pi pi-lock';
            break;

            case 11: //IMPRESO
                color = 'green-300';
                textcolor = 'green-600';
                icon = 'pi pi-lock';
            break;

            case 12: //POR FIRMAR
                color = 'green-300';
                textcolor = 'green-600';
                icon = 'pi pi-lock';
            break;

            case 13: //FIRMADO
                color = 'green-200';
                textcolor = 'green-500';
                icon = 'pi pi-lock';
            break;

            case 14: //CORREGIDO
                color = 'green-300';
                textcolor = 'green-600';
                icon = 'pi pi-lock';
            break;
            
            default:
                color = 'orange-100';
                textcolor = 'orange-600';
                icon = 'pi pi-bell';
            break;    
        }
       
        return (
                <div className="flex align-items-center">
                    <span className={`inline-flex border-circle align-items-center justify-content-center bg-${color} mr-3`} style={iconstyle}><i className={`${icon} text-xl text-${textcolor}`}></i></span>
                    <span className="text-900 font-medium text-2xl">{statusText}</span>
                </div>
        );
    }

    return (
        <>
            {!data ? (
                <MessageDetail mensaje="No se encontraron solicitudes registradas"/>
            ):(
                data.map((el, index) => 
                    <div className="col-12 lg:col-4 p-3" key={index}>
                        <div className="shadow-2 border-round surface-card mb-3 h-full flex-column justify-content-between flex">
                            <div className="p-4">
                                {handleStatus(el.statusid, el.status)}
                                <div className="text-900 my-3 text-xl font-medium text-center">{el.nombre + ' ' + el.apellido1 + ' ' + el.apellido2}</div>
    
                                {(el.statusid == 5 ? 
                                    (el.rechazados > 0 ? <div className="font-bold text-center my-3">CANTIDAD DE DOCUMENTOS ADJUNTOS CON OBSERVACIONES: {el.rechazados}</div> : "")
                                : "")}

                                {(el.statusid == 5 ? 
                                    (el.observacion && <div className="text-center my-3"><strong>OBSERVACIÓN GENERAL</strong><br />{el.observacion}</div>)
                                : "")}
                                     
                            </div>
                            <div className="col-12">
                                <ul className="list-none p-10 m-0 flex-grow-1">
                                    <li className="flex align-items-center mb-3"><i className="pi pi-check-circle text-green-500 mr-2"></i><span>{el.institucion_educativa}</span></li>
                                    <li className="flex align-items-center mb-3"><i className="pi pi-check-circle text-green-500 mr-2"></i><span>{el.carrera}</span></li>
                                    <li className="flex align-items-center mb-3"><i className="pi pi-check-circle text-green-500 mr-2"></i><span>{el.correo_electronico}</span></li>
                                    <li className="flex align-items-center mb-3"><i className="pi pi-check-circle text-green-500 mr-2"></i><span>{el.telefono}</span></li>
                                    <li className="flex align-items-center mb-3"><i className="pi pi-check-circle text-green-500 mr-2"></i><span>REGISTRO: {el.fecha_registro}</span></li>
                                    <li className="flex align-items-center mb-3"><i className="pi pi-check-circle text-green-500 mr-2"></i><span>{el.pais}, {el.entidad}</span></li>
                                </ul>
                            </div>
                            <div className="px-4 py-3 surface-100 text-right">
                                {([3, 5, 8, 9].includes(el.statusid) &&
                                    <Link to={`/editar/${el.solicitudid}`}>
                                        <Button label="Editar" className="p-button-rounded p-button-outlined mr-2 mb-2"></Button>
                                    </Link>
                                )}
                                <Button type="button" className="p-button-rounded mr-2 mb-2" label={(el.statusid == 3 ? `Adjuntar Documentos`:`Ver Documentos`)} icon="pi pi-paperclip" onClick={() => handleDigitization(el.solicitudid)} />
                            </div>
                        </div>
                    </div>
                )
            )}
        </>
    );  
}

export default TableData;